import {
  SERVICE_ORDER_STATUSES,
  type ServiceOrder,
  type ServiceOrderStatus,
} from '#admin/features/exhibitor/service-orders-api.ts'
import { matchesQuery } from '#admin/lib/text-search.ts'

/**
 * The search and the status filter of the service orders list. They live in the URL, so the
 * dashboard can link to "the submitted orders", and a reload or Back keeps the view.
 *
 * Every key is returned, `undefined` when dropped: the router spreads this over the raw search,
 * so a key left out would keep its raw value.
 */
export type ServiceOrderSearch = {
  q?: string | undefined
  status?: ServiceOrderStatus | undefined
}

export function parseServiceOrderSearch(search: Record<string, unknown>): ServiceOrderSearch {
  const raw = search['q']
  const q = typeof raw === 'string' ? raw.trim().slice(0, 200) : ''
  return {
    q: q === '' ? undefined : q,
    status: SERVICE_ORDER_STATUSES.find((status) => status === search['status']),
  }
}

/** The search looks in the company name, the application reference and the order id. */
export function matchesServiceOrder(
  order: Pick<ServiceOrder, 'id' | 'status' | 'companyName' | 'applicationCode'>,
  search: ServiceOrderSearch,
): boolean {
  return (
    (search.status === undefined || order.status === search.status) &&
    matchesQuery([order.companyName, order.applicationCode, order.id], search.q ?? '')
  )
}
